function Yourny() {
    return (
        <>
        
        <div className="App d-flex justify-content-center bg-dark text-white">
                <div class="col-2"><p>anuncios</p></div>
                <div class="col-8 bg-dark text-white">
                    <form>
                        <div class="mb-3 mt-3">
                            <label for="email" class="form-label">Titulo de la publicación:</label>
                            <input type="email" class="form-control" id="titulo" placeholder="Enter email" name="titulo"/>
                        </div>
                        <div class="mb-3">
                            <label for="pwd" class="form-label">Imagenes:</label>
                            <input type="file" class="form-control" id="imagen" placeholder="Enter password" name="imagen"/>
                        </div>
                        <div class="form-check mb-3">
                            <label class="form-check-label">
                            <input class="form-check-input" type="checkbox" name="espublico"/> ¿será publica?
                            </label>
                        </div>
                        <button type="submit" class="mx-3 btn btn-primary">publicar</button>
                        <button type="submit" class="mx-3 btn btn-secondary">cancelar</button>
                    </form>
                </div>
                <div class="col-2"><p>anuncios</p></div>
            </div>
            <title>Yourny</title>
        </>
    );
}



export default Yourny;